<div class="loading-section">
    <mat-spinner></mat-spinner>
</div>
